












































































import { Vue } from "vue-property-decorator"
import BasicTable from "@/components/Table/BasicTable.vue"
import ChooseMember from '@/views/invest_team/choose.vue'
import { invest_team_member } from "@/@types/invest/invest_team"

export default Vue.extend({
  name      : "InvestTeams",
  components: { BasicTable, ChooseMember },
  data() {
    return {
      data   : [] as invest_team_member[],
      columns: [
        { dataIndex: "id", title: "编号", align: "center", width: 60 },
        { dataIndex: "wechat_nickname", title: "昵称", align: "center", width: 80 },
        { dataIndex: "avatar", title: "头像", align: "center", width: 100, scopedSlots: { customRender: "customRender" } },
        { dataIndex: "mobile", title: "手机号", align: "center", width: 100 },
        { dataIndex: "username", title: "姓名", align: "center", scopedSlots: { customRender: "customRender" } },
        { dataIndex: "role", title: "角色", width: 100, align: "center", scopedSlots: { customRender: "customRender" } },
        { dataIndex: "is_invalid", title: "在岗状态", width: 100, align: "center", scopedSlots: { customRender: "customRender" } },
        { dataIndex: "config", title: "分配场馆", width: 80, align: "center", scopedSlots: { customRender: "customRender" } },
        { dataIndex: "new", title: "新建场馆", width: 80, align: "center", scopedSlots: { customRender: "customRender" } },
        { dataIndex: "invalid", title: "失效场馆", width: 80, align: "center", scopedSlots: { customRender: "customRender" } },
        { dataIndex: "estimate", title: "评估场馆", width: 80, align: "center", scopedSlots: { customRender: "customRender" } },
        { dataIndex: "cooperate", title: "合作场馆", width: 80, align: "center", scopedSlots: { customRender: "customRender" } },
        { dataIndex: "action", title: "操作", width: 240, align: "center", scopedSlots: { customRender: "customRender" } },
      ],
      keywords: {
        username       : "",
        mobile         : "",
        wechat_nickname: "",
        status         : -1
      },
      roles   : ["投资经理管理", "投资经理"],
      invalids   : [
        { label: "在职", status: "success" },
        { label: "离职", status: "error" }
      ],
      statuses: [
        { label: "离职", value: 0 },
        { label: "在职", value: 1 },
        { label: "全部", value: -1 },
      ],
      transfers  : [] as number[],
      choose_user: {
        visible: false,
        loading: false,
        title  : "移交场馆",
        desc   : ""
      }
    }
  },
  methods: {
    search() {
      const table = this.$refs.table as any;
      table.Search()
    },
    transfer(record: any) {
      if (record.is_invalid != "1") {
        this.$confirm({
          title  : `投资经理“${record.username}”尚未离职，是否继续移交场馆？`,
          content: "移交后将发送信息通知场馆原所属投资经理",
          okText : "继续移交",
          onOk   : () => {
            this.openChoose(record.id)
          }
        })
      }
    },
    async do_transfer(user_id: number) {
      const params = { stadium_ids: this.transfers.join(","), user_id, is_transfer: 1 }
      const res = await this.$store.dispatch("invest/config_stadium", params);
      if (res.Code == 200) {
        this.$info({
          content: "移交成功！",
          onOk   : () => {
            this.search()
            const choose = this.$refs.choose_member as any
            choose.close()
          }
        })
      } else {
        this.$confirm({
          content: "移交失败！",
          okText : "重试",
          onOk   : () => { this.do_transfer(user_id) }
        })
      }
    },
    async openChoose(user_id: number) {
      const res = await this.$store.dispatch("invest_team/my_stadiums", { user_id });
      const temp = []
      if (res.Code == 200) {
        if (res.Data != null) {
          for (const item of res.Data) {
            temp.push(item.stadium_id)
          }
        }
        this.choose_user.desc = `将 ${temp.length} 家场馆，移交给：`
        this.transfers = temp
      }
      if (temp.length == 0) {
        this.$info({ content: "没有可以移交的场馆！" })
      } else {
        const choose: any = this.$refs.choose_member
        choose.visible = true
      }
    },
    job(record: any) {
      let message = ""
      if (record.is_invalid == "1") message = `确定将“${record.username}”设置为在职状态`
      else message = `确定将“${record.username}”设置为离职状态`
      this.$confirm({
        content: message,
        onOk: () => {
          this.set_job(record)
        }
      })
    },
    async set_job(record: any) {
      const params = { user_id: Number(record.id), status: Number(record.is_invalid) }
      const res = await this.$store.dispatch("invest_team/setup_job", params);
      if (res.Code == 200) {
        this.$info({
          content: "设置成功",
          okText : "确定",
          onOk: () => this.search()
        })
      } else {
        this.$confirm({
          content: "设置失败",
          okText: "重试",
          onOk:() => {
            this.set_job(record)
          }
        })
      }
    }
  },
  mounted() {
    this.search()
  },
})

